import React from 'react';
import {BaseProvider } from 'baseui';
import { Provider as StyletronProvider, DebugEngine } from 'styletron-react';
import { Client as Styletron } from 'styletron-engine-atomic';
import { LightTheme, DarkTheme } from './customTheme'
import { useDarkMode } from '../hooks/useDarkMode'

interface ThemeProviderProps {
  children: React.ReactNode;
}

const engine = new Styletron();

export const ThemeProvider = ({ children }: ThemeProviderProps) => {

  const { isDarkMode, toggle, enable, disable } = useDarkMode()
  const theme = isDarkMode ? DarkTheme : LightTheme;

  //const debug = new DebugEngine();

  return (
    <StyletronProvider value={engine} >
        <BaseProvider
          theme={theme}
          overrides={{
            AppContainer: {
              style: {
                height: '100vh',
                width: '100vw',
                //background: theme.colors.backgroundSecondary
              },
            },
          }}
        >
          {children}
        </BaseProvider>
    </StyletronProvider>
  );
}

export default ThemeProvider;
